import { authenticationReducer } from './authentication-reducer';
import { claimsReducer } from './claims-reducer';
import { clientsReducer } from './clients-reducer';
import { combineReducers } from 'redux';
import { policiesReducer } from './policies-reducer';
import { productsReducer } from './products-reducer';
import { usersReducer } from './users-reducer';

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  clients: clientsReducer,
  claims: claimsReducer,
  users: usersReducer,
  products: productsReducer,
  policies: policiesReducer,
});

export default rootReducer;
